module.exports = __webpack_public_path__ + "fonts/Blox2.27da4554.ttf";